module.exports = __webpack_public_path__ + "static/media/user_management.4577472a.svg";